var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{class:_vm.themeClass,attrs:{"title":_vm.title,"left-text":"","right-text":_vm.rightText,"left-arrow":_vm.leftArrow,"fixed":true,"border":false},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}})
}
var staticRenderFns = []

export { render, staticRenderFns }